import { MenuDropdown, NavbarItem } from "components/UI/molecules";
import { MenuCart, NavbarSearch } from "..";
import "./index.scss";
import { GcxLogo } from "components/UI/molecules/gcx-logo";
import { useCallback, useState } from "react";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { useAppContext } from "context/app-context";
import { GcxCash } from "components/UI/atoms";

export const DesktopNavbar = ({
  leftSideItems,
  rightSideItems,
  menuItems,
  isHomePage = false,
  isTopScreen = false
}) => {
  const { sessionInfo } = useAppContext();
  const [brands, setBrands] = useState([]);
  const { width } = useWindowDimensions();

  const handleBrandsChange = useCallback((brandsChanged) => {
    setBrands(brandsChanged);
  }, []);

  const isMobile = width <= 768;
  const isLoggedIn = sessionInfo && sessionInfo.isLoggedIn;

  return (
    <div
      className={`container-navbar ${isTopScreen && "isTopScreen"}`}
      data-testid="desktop-navbar"
    >
      <ul className="left-section">
        <li>
          <GcxLogo
            data-test-id="logo-small"
            version={isMobile ? "icon" : "small"}
          />
        </li>
        {!isHomePage && (
          <li>
            <NavbarSearch brands={brands} onBrandsChange={handleBrandsChange} />
          </li>
        )}
        {leftSideItems.map((item) => (
          <NavbarItem
            label={item.label}
            path={item.path}
            logId={item.logId}
            key={item.logId}
          />
        ))}
      </ul>
      <ul className="right-section">
        {isLoggedIn && (
          <li>
            <GcxCash value={sessionInfo.gcxCash} />
          </li>
        )}
        {rightSideItems.map((item) => {
          const displayItem = !isLoggedIn || (isLoggedIn && item.showLogged);

          return displayItem ? (
            <NavbarItem
              label={item.label}
              path={item.path}
              logId={item.logId}
              isExternalLink={item.isExternalLink}
              onClick={item.onClick}
              key={item.logId}
            />
          ) : null;
        })}
        {isLoggedIn && (
          <li>
            <MenuDropdown items={menuItems} />
          </li>
        )}
        <li>
          <MenuCart />
        </li>
      </ul>
    </div>
  );
};
